// extracted by mini-css-extract-plugin
export var dividerLine = "_45-0";
export var errorBackground = "_45-1";